import type { IServiceStatusResponse } from "../types/types";
import Legend from "./Legend";
import ServiceItem from "./ServiceItem";

interface ServiceStatusProps {
  data?: IServiceStatusResponse;
  isLoading?: boolean;
}

const ServiceStatus = ({ data, isLoading }: ServiceStatusProps) => {
  if (isLoading) {
    return (
      <div className="w-full overflow-hidden rounded-[20px] border border-neutral-200">
        {/* Header skeleton */}
        <div className="flex items-center justify-between bg-neutral-200 px-4 py-3 sm:px-6 sm:py-4">
          <div className="h-6 w-36 animate-pulse rounded-md bg-neutral-300" />
          <div className="flex items-center gap-3">
            <div className="h-5 w-16 animate-pulse rounded-md bg-neutral-300" />
            <div className="h-5 w-16 animate-pulse rounded-md bg-neutral-300" />
          </div>
        </div>

        {/* Service item skeletons */}
        <div className="grid grid-cols-1 divide-y border-neutral-200 sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="flex items-center justify-between px-4 py-5 sm:px-6"
            >
              <div className="h-5 w-28 animate-pulse rounded-md bg-neutral-200" />
              <div className="h-6 w-16 animate-pulse rounded-full bg-neutral-200" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!data?.services) {
    return null;
  }

  const { database, redis, elasticsearch } = data.services;

  return (
    <div className="w-full overflow-hidden rounded-[20px] border border-neutral-200">
      <div className="flex items-center justify-between bg-neutral-200 px-4 py-3 sm:px-6 sm:py-4">
        <h2 className="text-[20px] font-bold -tracking-wide text-neutral-950">
          Service Status
        </h2>

        <div className="flex items-center gap-3 text-sm">
          <Legend label="Online" color="green" icon="ri-check-line" />
          <Legend label="Offline" color="red" icon="ri-close-line" />
        </div>
      </div>

      <div className="divide-border grid grid-cols-1 divide-y sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:grid-cols-3">
        <ServiceItem
          name="Database"
          status={database as "online" | "offline"}
        />
        <ServiceItem name="Redis" status={redis as "online" | "offline"} />
        <ServiceItem
          name="Elasticsearch"
          status={elasticsearch as "online" | "offline"}
        />
      </div>
    </div>
  );
};

export default ServiceStatus;
